import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
`;

export const UsenPhoto = styled.div`
    width: 30px;
    height: 30px;
    color: #000;
    background-color: ${props => props.color};
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: 900;
`;

export const MessageWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const MessageSender = styled.div`
    width: 100%;
    height: 15px;
    font-size: 12px;
    color: ${props => props.color};
    font-weight: 900;
`;

export const MessageData = styled.div`
    width: 100%;
    padding: 10px 10px 0;
    background-color: #333;
    box-shadow: 0 2px 3px rgba(0,0,0, 0.4);
    position: relative;

    :before {
        content: '';
        position: absolute;
        top: 0;
        left: -10px;
        z-index: 2;
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-top: 10px solid #333;
    }
`;

export const MessageLine = styled.div`
    color: #bbb;
    padding-bottom: 10px;
    overflow: hidden;
    word-break: break-all;
`;

export const MessageTime = styled.div`
    color: #666;
    font-size: 12px;
    text-align: right;
    padding: 5px 0;
`;

export const LabelText = styled.div`
    color: #777;
    font-size: 12px;
    text-align: center;
    font-style: italic;
    padding: 0;
`;

export const DiceStreak = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const LabelStreak = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const Rule = styled.div``;
export const RuleTitle = styled.div`
    color: #bbb;
    font-style: italic;
    font-size: 16px;
    margin: 20px 0 10px;
    text-align: center;
`;

export const RuleDesc = styled.div`
    white-space: pre-line;
    color: #aaa;
    font-size: 14px;
    word-break: break-word;
    text-align: justify;
    padding: 0 20px 20px;
    line-height: 20px;

    & b {
        font-weight: 900;
        color: #ccc;
    }
    & i {
        font-style: italic;
    }
    & s {
        text-decoration: line-through;
    }
`;

export const SeparatorLine = styled.div`
    width: 100%;
    height: 2px;
    background-color: #555;
    border-top: 1px solid #000;
    margin: 10px 0;
`;
